import intersect from './intersect';

const directives = {
  intersect,
};

export default {
  install(Vue) {
    Object.keys(directives).forEach(item => {
      Vue.directive(item, directives[item]);
    });
  },
}



// WEBPACK FOOTER //
// ./src/directives/index.js